import Api from '../http.service';
/**
 * @param {object} payload
 * @param {number} payload.pagenumber
 * @param {number} payload.itemperpage
 * @param {object} payload.data
 * @param {string} payload.data.createdStartDate
 * @param {string} payload.data.createdEndDate
 * @param {string} payload.data.expieryStartDate
 * @param {string} payload.data.expieryEndDate
 * @param {string} payload.data.creditStatusId
 */
export const GetProfileCredit = (payload) =>
  Api.POST({
    url: `credit/profile_credits_me/${payload.pagenumber - 1}/${
      payload.itemperpage
    }`,
    data: payload.data,
  });

export const getCreditSummery = () =>
  Api.GET({ url: 'credit/all_credits_summary_me' });

/**
 * @param {object} payload
 * @param {number} payload.pageNumber
 * @param {number} payload.itemPerPage
 * @param {string} payload.creditId
 */

export const getAllExpansesByCreditId = (payload) =>
  Api.GET({
    url: `credit/credit_expenses/${payload.creditId}/${
      payload.pageNumber - 1
    }/${payload.itemPerPage}`,
  });
